// pages/user/Sidebar.jsx
import React from "react";
import { FaUserAlt } from "react-icons/fa";
import {
  FiBarChart2,
  FiUser,
  FiPackage,
  FiHeart,
  FiLogOut,
} from "react-icons/fi";

const Sidebar = ({
  auth,
  activeTab,
  setActiveTab,
  setSidebarOpen, // Not strictly needed for this design but kept for props compatibility
  onLogout,
}) => {
  const menuItems = [
    { id: "statistics", icon: FiBarChart2, label: "Dashboard" },
    { id: "profile", icon: FiUser, label: "Profile" },
    { id: "orders", icon: FiPackage, label: "My Orders" },
    { id: "wishlist", icon: FiHeart, label: "Wishlist" },
  ];

  const handleItemClick = (id) => {
    setActiveTab(id);
    if (setSidebarOpen) {
      setSidebarOpen(false);
    }
  };

  return (
    <>
      {/* DESKTOP SIDEBAR (Visible on Large Screens)                         */}
      <div className="hidden lg:block rounded-lg shadow-sm p-6 sticky top-24 bg-white border border-gray-200">
        {/* User Profile Section */}
        <div className="mb-8 pb-6 border-b border-gray-200">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center text-white text-4xl">
              <FaUserAlt />
            </div>
            <div>
              <h3 className="text-gray-900 font-bold text-lg">
                {auth?.user?.name}
              </h3>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="space-y-2">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className={`w-full flex items-center gap-3 py-3 px-4 transition-all duration-200 rounded-lg ${
                activeTab === item.id
                  ? "text-gray-900 font-semibold bg-gray-100"
                  : "text-gray-400 hover:text-gray-600 hover:bg-gray-50"
              }`}
              onClick={() => handleItemClick(item.id)}
            >
              <item.icon size={20} />
              {item.label}
            </button>
          ))}
        </nav>

        {/* Logout Button */}
        <button
          onClick={onLogout}
          className="w-full mt-8 flex items-center justify-center gap-3 py-3 px-4 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-900 font-semibold transition-all duration-200"
        >
          <FiLogOut size={20} />
          Logout
        </button>
      </div>

      {/* MOBILE/TABLET BOTTOM NAV (Always Open) */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 pb-safe z-50">
        <div className="flex items-center justify-between px-2 py-2">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleItemClick(item.id)}
              className={`flex flex-col items-center justify-center w-full py-2 rounded-lg transition-colors ${
                activeTab === item.id
                  ? "text-gray-900"
                  : "text-gray-400 hover:text-gray-600"
              }`}
            >
              <div
                className={`p-1.5 rounded-full mb-1 transition-all ${
                  activeTab === item.id
                    ? "bg-gray-900 text-white"
                    : "bg-transparent"
                }`}
              >
                <item.icon
                  size={20}
                  strokeWidth={activeTab === item.id ? 2.5 : 2}
                />
              </div>
              <span className="text-[10px] font-medium truncate max-w-[60px]">
                {item.label}
              </span>
            </button>
          ))}

          {/* Mobile Logout */}
          {/* <button
            onClick={onLogout}
            className="flex flex-col items-center justify-center w-full py-2 text-red-400 hover:text-red-600"
          >
            <div className="p-1.5 mb-1">
              <FiLogOut size={20} />
            </div>
            <span className="text-[10px] font-medium">Logout</span>
          </button> */}
        </div>
      </div>

      {/* Spacer for Mobile Content */}
      
    </>
  );
};

export default Sidebar;
